// Goblin Wood — "Blanket season" section. Interaction logic ported from
// the approved mockup (theme-backup/_source-art/night-in-crate-mockup-
// source.html) and rewired to real product data: real blanket/mug
// listings instead of the mockup's sample arrays, one real /cart/add.js
// call via window.gwInterceptAddToCartMulti (which also opens the
// existing gw-cart-drawer) instead of the mockup's fake toast().
(function () {
  function money(minor) {
    return '£' + (minor / 100).toFixed(2);
  }

  function initSection(root) {
    // Coming soon mode: the veiled content is inert (not clickable, not
    // focusable, hidden from screen readers via the `inert` attribute in
    // the Liquid) and the only interactive thing on the section is the
    // plain server-rendered {% form 'customer' %} waitlist form, which
    // needs no JS at all. Bail out before wiring any add-to-cart/mug-
    // sheet/carousel behaviour.
    if (root.hasAttribute('data-gwbs-coming-soon')) return;

    var dataEl = root.querySelector('[data-gwbs-data]');
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var blankets = data.blankets || [];
    var mugs = data.mugs || [];
    var mystery = data.mystery;
    var snack = data.snack;

    // ---- Blanket row: filter chips + track ----
    var chipsEl = root.querySelector('[data-gwbs-chips]');
    var trackEl = root.querySelector('[data-gwbs-track]');
    var trackArrowsEl = root.querySelector('[data-gwbs-track-arrows]');
    var trackPrevBtn = root.querySelector('[data-gwbs-track-prev]');
    var trackNextBtn = root.querySelector('[data-gwbs-track-next]');

    function trackStep() {
      var col = trackEl.querySelector('.gwbs__frame-col');
      return col ? col.offsetWidth : 230;
    }

    function updateTrackArrows() {
      if (!trackArrowsEl) return;
      var fits = trackEl.scrollWidth <= trackEl.clientWidth + 1;
      trackArrowsEl.hidden = fits;
      if (fits) return;
      var atStart = trackEl.scrollLeft <= 0;
      var atEnd = trackEl.scrollLeft + trackEl.clientWidth >= trackEl.scrollWidth - 1;
      if (trackPrevBtn) trackPrevBtn.classList.toggle('is-disabled', atStart);
      if (trackNextBtn) trackNextBtn.classList.toggle('is-disabled', atEnd);
    }

    if (trackPrevBtn) {
      trackPrevBtn.addEventListener('click', function () {
        trackEl.scrollBy({ left: -trackStep(), behavior: 'smooth' });
      });
    }
    if (trackNextBtn) {
      trackNextBtn.addEventListener('click', function () {
        trackEl.scrollBy({ left: trackStep(), behavior: 'smooth' });
      });
    }
    if (trackEl) {
      trackEl.addEventListener('scroll', updateTrackArrows, { passive: true });
      window.addEventListener('resize', updateTrackArrows);
    }

    function renderTrack(filter) {
      if (!trackEl) return;
      trackEl.innerHTML = '';
      blankets
        .filter(function (b) { return filter === 'all' || b.sideKey === filter; })
        .forEach(function (b, i) {
          var no = String(i + 1).padStart(2, '0');
          var col = document.createElement('article');
          col.className = 'gwbs__frame-col';
          // Heart top-left on the frame (v7 — this carousel had no heart
          // at all before; same shared gw-heart markup/behaviour as
          // every other card, wired via initHearts() below).
          col.innerHTML =
            '<div class="gwbs__frame">' +
              '<img src="' + b.image + '" alt="' + b.title + '">' +
              '<span class="gwbs__edge">' + b.side + ' ▸ ' + no + '</span>' +
              '<span class="gwbs__edge gwbs__edge--r">GW ' + no + 'A</span>' +
              '<button type="button" class="gw-quick-add" aria-label="Add ' + b.title + '">' +
                '<span class="gw-quick-add__pill">Add to bag</span>' +
                '<span class="gw-quick-add__icon">' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
                    '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
                    '<line x1="3" y1="6" x2="21" y2="6"/>' +
                    '<path d="M16 10a4 4 0 01-8 0"/>' +
                  '</svg>' +
                '</span>' +
              '</button>' +
              '<button type="button" class="gw-heart gwbs__frame-heart" data-gw-heart data-gw-heart-handle="' + (b.handle || '') + '" aria-pressed="false" aria-label="Add to wishlist">' +
                '<span class="gw-heart__icon-wrap">' +
                '<svg class="gw-heart__icon gw-heart__icon--outline" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
                '<svg class="gw-heart__icon gw-heart__icon--filled" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
                '</span>' +
                '<span class="gw-heart__label" data-gw-heart-label aria-hidden="true"></span>' +
              '</button>' +
            '</div>' +
            '<div class="gwbs__frame-meta">' +
              '<b>' + b.title + '</b><span>' + money(b.price) + '</span>' +
            '</div>';
          col.querySelector('.gw-quick-add').addEventListener('click', function () {
            openSheet(b);
          });
          trackEl.appendChild(col);
        });
      trackEl.scrollLeft = 0;
      updateTrackArrows();
      if (window.gwWishlist && window.gwWishlist.initHearts) window.gwWishlist.initHearts(trackEl);
    }

    if (chipsEl) {
      chipsEl.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-gwbs-filter]');
        if (!chip) return;
        Array.prototype.forEach.call(chipsEl.children, function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        renderTrack(chip.dataset.gwbsFilter);
      });
    }
    renderTrack('all');

    // ---- Crate hero: mode toggle + side pick + packing list + extras ----
    var packingList = data.packingList || [];
    var candles = data.candles || {};
    var bingo = data.bingo;

    var modeEl = root.querySelector('[data-gwbs-mode]');
    var sidesEl = root.querySelector('[data-gwbs-sides]');
    var slipEl = root.querySelector('[data-gwbs-slip]');
    var tagPriceEl = root.querySelector('[data-gwbs-tag-price]');
    var tagWorthEl = root.querySelector('[data-gwbs-tag-worth]');
    var snackCheck = root.querySelector('[data-gwbs-snack-check]');
    var allergyEl = root.querySelector('[data-gwbs-allergy]');
    var allergyOpts = Array.prototype.slice.call(root.querySelectorAll('[data-gwbs-allergy-opt]'));
    var allergyOtherCheck = root.querySelector('[data-gwbs-allergy-other]');
    var allergyOtherText = root.querySelector('[data-gwbs-allergy-text]');
    var bingoRow = root.querySelector('[data-gwbs-bingo-row]');
    var bingoCheck = root.querySelector('[data-gwbs-bingo-check]');
    var addonsLabelEl = root.querySelector('[data-gwbs-addons-label]');
    var addBtn = root.querySelector('[data-gwbs-add]');
    var ctaEl = root.querySelector('[data-gwbs-cta]');
    var totalEl = root.querySelector('[data-gwbs-total]');

    var mode = 'solo';
    var selectedSide = null;

    function modePrice() {
      if (!mystery) return 0;
      var m = mode === 'party' && mystery.party ? mystery.party : mystery.solo;
      return m.price;
    }

    function modeVariantId() {
      if (!mystery) return null;
      var m = mode === 'party' && mystery.party ? mystery.party : mystery.solo;
      return m.variantId;
    }

    function renderSlip() {
      if (!slipEl) return;
      var isParty = mode === 'party';
      var worth = 0;
      var html = '<span class="gwbs__slip-h">Packing list</span>';
      packingList.forEach(function (item) {
        var qty = isParty ? item.partyQty : item.soloQty;
        if (!qty) return;
        var label = (qty > 1 && item.pluralLabel) ? item.pluralLabel : item.label;
        var qtyHtml = qty > 1 ? '<span class="gwbs__li-q">' + qty + ' × </span>' : '';
        var candleHtml = '';
        if (item.showCandleName) {
          var name = selectedSide && candles[selectedSide.key] ? '"' + candles[selectedSide.key] + '"' : 'for your side';
          candleHtml = ' <small>' + name + '</small>';
        }
        var valueHtml;
        if (item.free) {
          valueHtml = '<span class="gwbs__li-v gwbs__li-v--free">Free</span>';
        } else {
          var lineValue = item.value * qty;
          worth += lineValue;
          valueHtml = '<span class="gwbs__li-v">' + money(lineValue) + '</span>';
        }
        html +=
          '<div class="gwbs__li">' +
            '<span class="gwbs__li-n">' + qtyHtml + label + candleHtml + '</span>' +
            '<span class="gwbs__li-d"></span>' +
            valueHtml +
          '</div>';
      });
      html +=
        '<div class="gwbs__li gwbs__li--tot">' +
          '<span class="gwbs__li-n">Worth</span>' +
          '<span class="gwbs__li-d"></span>' +
          '<span class="gwbs__li-v">' + money(worth) + '</span>' +
        '</div>';
      slipEl.innerHTML = html;
      return worth;
    }

    function updateHero() {
      if (!mystery) return;
      var worth = renderSlip();
      if (tagPriceEl) tagPriceEl.textContent = money(modePrice());
      if (tagWorthEl) tagWorthEl.textContent = 'worth ' + money(worth);

      if (bingoRow) bingoRow.hidden = mode === 'party';
      if (mode === 'party' && bingoCheck) bingoCheck.checked = false;

      if (addonsLabelEl) {
        var anyExtraVisible = !!snackCheck || (bingoRow && !bingoRow.hidden);
        addonsLabelEl.hidden = !anyExtraVisible;
      }

      var total = modePrice();
      if (snackCheck && snackCheck.checked && snack) {
        // Match the "+£X" promised on the checkbox row, not the snack
        // pack's undiscounted price — the automatic discount applies at
        // checkout anyway since the crate alone already clears its £15
        // minimum, so this is what the customer will actually pay.
        total += snack.displayPrice;
      }
      if (mode !== 'party' && bingoCheck && bingoCheck.checked && bingo) {
        total += bingo.price;
      }
      if (totalEl) totalEl.textContent = money(total);

      if (allergyEl) allergyEl.hidden = !(snackCheck && snackCheck.checked);

      if (addBtn && ctaEl) {
        if (selectedSide) {
          addBtn.disabled = false;
          ctaEl.textContent = 'Add ' + selectedSide.label + (mode === 'party' ? ' Binge Party' : '') + ' crate to bag';
        } else {
          addBtn.disabled = true;
          ctaEl.textContent = 'Pick your side first';
        }
      }
    }

    if (modeEl) {
      modeEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gwbs-mode-btn]');
        if (!btn) return;
        mode = btn.dataset.mode;
        Array.prototype.forEach.call(modeEl.children, function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        updateHero();
      });
    }

    if (sidesEl) {
      sidesEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gwbs-side]');
        if (!btn) return;
        Array.prototype.forEach.call(sidesEl.children, function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        selectedSide = { key: btn.dataset.sideKey, label: btn.dataset.sideLabel };
        updateHero();
      });
    }
    if (snackCheck) {
      snackCheck.addEventListener('change', updateHero);
    }
    if (bingoCheck) {
      bingoCheck.addEventListener('change', updateHero);
    }
    if (allergyOtherCheck && allergyOtherText) {
      allergyOtherCheck.addEventListener('change', function () {
        allergyOtherText.hidden = !allergyOtherCheck.checked;
      });
    }
    if (mystery) updateHero();

    function allergyPropertyValue() {
      var parts = allergyOpts.filter(function (o) { return o.checked; }).map(function (o) { return o.value; });
      if (allergyOtherCheck && allergyOtherCheck.checked) {
        var note = allergyOtherText && allergyOtherText.value.trim();
        parts.push(note ? 'Other: ' + note : 'Other');
      }
      return parts.join(', ');
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!selectedSide || !mystery || typeof window.gwInterceptAddToCartMulti !== 'function') return;
        var items = [
          { id: modeVariantId(), quantity: 1, properties: { Side: selectedSide.label } },
        ];
        if (snackCheck && snackCheck.checked && snack) {
          var snackItem = { id: snack.variantId, quantity: 1 };
          var allergies = allergyPropertyValue();
          if (allergies) snackItem.properties = { Allergies: allergies };
          items.push(snackItem);
        }
        if (mode !== 'party' && bingoCheck && bingoCheck.checked && bingo) {
          items.push({ id: bingo.variantId, quantity: 1 });
        }
        addBtn.disabled = true;
        window.gwInterceptAddToCartMulti(items).catch(function () {
          addBtn.disabled = false;
        });
      });
    }

    // ---- Mug sheet ----
    var sheetEl = root.querySelector('[data-gwbs-sheet]');
    var mugsBoxEl = root.querySelector('[data-gwbs-mugs]');
    var skipBtn = root.querySelector('[data-gwbs-skip]');
    var currentBlanket = null;

    function pickMugs(blanket) {
      var matching = mugs.filter(function (m) { return m.sideKey === blanket.sideKey; });
      var rest = mugs.filter(function (m) { return m.sideKey !== blanket.sideKey; });
      return matching.concat(rest).slice(0, 3);
    }

    function closeSheet() {
      if (sheetEl) sheetEl.hidden = true;
    }

    function openSheet(blanket) {
      if (!sheetEl || !mugsBoxEl) return;
      currentBlanket = blanket;
      mugsBoxEl.innerHTML = '';
      pickMugs(blanket).forEach(function (m) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gwbs__mug';
        btn.innerHTML = '<img src="' + m.image + '" alt="">' + m.title + ' · ' + money(m.price);
        btn.addEventListener('click', function () {
          closeSheet();
          if (typeof window.gwInterceptAddToCartMulti !== 'function') return;
          window.gwInterceptAddToCartMulti([
            { id: blanket.variantId, quantity: 1 },
            { id: m.variantId, quantity: 1 },
          ]);
        });
        mugsBoxEl.appendChild(btn);
      });
      sheetEl.hidden = false;
    }

    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        closeSheet();
        if (!currentBlanket || typeof window.gwInterceptAddToCartMulti !== 'function') return;
        window.gwInterceptAddToCartMulti([{ id: currentBlanket.variantId, quantity: 1 }]);
      });
    }
    if (sheetEl) {
      sheetEl.addEventListener('click', function (e) {
        if (e.target === sheetEl) closeSheet();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSheet();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gwbs]').forEach(initSection);
  });
})();
